import _ from 'lodash';
import numeral from 'numeral';
 
export function numFormat(numValue: number, disableDecimal: boolean = false): string | number {
  if (isNaN(numValue)) return '';

  let result = numeral(numValue).format('0,0.00');
  if (disableDecimal) {
    result = numeral(numValue).format('0,0');
  }
  if (result !== 'NaN') return result;
  
  if(numValue < 0.000001) {
    result = numeral(_.ceil(numValue, 5)).format('0.00');
    if (result !== 'NaN') return result;
  }
  
  result = numeral(numValue).format('0.00e+0');
  if (result !== 'NaN') return result;
  return numValue;
}

export function unitPriceFormat(unitPrice: number, skipCurrency: boolean = false): string | number {
  if (isNaN(unitPrice)) {
    return unitPrice;
  }
  const formattedPrice = numeral(unitPrice).format('0,0.00[000]');
  return skipCurrency ? formattedPrice : `SAR ${formattedPrice}`;
}